import { create } from "zustand";

export type VehiclePlayState = "stopped" | "forward" | "reverse";

interface VehicleState {
  /** 0..1 a lo largo de la polyline de la pista de automóvil. */
  progress: number;
  play: VehiclePlayState;
  /** m/s sobre la trayectoria (lento, educativo). */
  speed: number;
  forward: () => void;
  reverse: () => void;
  stop: () => void;
  reset: () => void;
  tick: (delta: number, pathLength: number) => void;
}

/**
 * Estado del vehículo en pista-auto: NO es simulador libre, solo una
 * trayectoria controlada (avanzar / detener / retroceder / reiniciar).
 */
export const useVehicleStore = create<VehicleState>()((set) => ({
  progress: 0,
  play: "stopped",
  speed: 2.2,
  forward: () => set({ play: "forward" }),
  reverse: () => set({ play: "reverse" }),
  stop: () => set({ play: "stopped" }),
  reset: () => set({ play: "stopped", progress: 0 }),
  tick: (delta, pathLength) =>
    set((s) => {
      if (s.play === "stopped" || pathLength <= 0) return s;
      const dir = s.play === "forward" ? 1 : -1;
      const next = Math.min(1, Math.max(0, s.progress + (dir * s.speed * delta) / pathLength));
      const done = next === 0 || next === 1;
      return { progress: next, play: done ? "stopped" : s.play };
    }),
}));
